import Immutable from 'immutable';
import createReducers from '../utils/createreducer';

import {
    ADMIN_GET_BASICS_REQUEST,
    ADMIN_GET_BASICS_SUCCESS,
    ADMIN_GET_CLUBS_REQUEST,
    ADMIN_GET_CLUBS_SUCCESS,
    ADMIN_GET_CLUB_SUCCESS,
    ADMIN_GET_MEMBERS_REQUEST,
    ADMIN_GET_MEMBERS_SUCCESS,
    ADMIN_GET_MEMBER_SUCCESS,
    ADMIN_GET_PIGEON_HOLE_SUCCESS,
    ADMIN_CREATE_CLUB_SUCCESS,
    ADMIN_UPDATE_CLUB_SUCCESS,
    ADMIN_DELETE_CLUB_SUCCESS,
    ADMIN_CREATE_MEMBER_SUCCESS,
    ADMIN_UPDATE_MEMBER_SUCCESS,
    ADMIN_DELETE_MEMBER_SUCCESS,
    ADMIN_CREATE_PIGEONHOLE_SUCCESS,
    ADMIN_UPDATE_PIGEONHOLE_SUCCESS,
    ADMIN_DELETE_PIGEONHOLE_SUCCESS,
    ADMIN_CREATE_PIGEON_SUCCESS,
    ADMIN_UPDATE_PIGEON_SUCCESS,
    ADMIN_DELETE_PIGEON_SUCCESS,
    ADMIN_CREATE_PIGEONS_SUCCESS,
    ADMIN_UPDATE_PIGEONS_SUCCESS,
    ADMIN_DELETE_PIGEONS_SUCCESS,
    ADMIN_CREATE_RINGSERIE_SUCCESS,
    ADMIN_UPDATE_RINGSERIE_SUCCESS,
    ADMIN_DELETE_RINGSERIE_SUCCESS,
    ADMIN_GET_STATION_SELECTIONS_SUCCESS,
    ADMIN_SELECT_STATIONS_SUCCESS,
    ADMIN_UNSELECT_STATIONS_SUCCESS,
    ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS,
    ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS,
    ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS,
    ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS,
    ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS,
    ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS,
    ADMIN_RESET_UPDATE_MARKINGS_SUCCESS,
    ADMIN_GET_SECTIONS_REQUEST,
    ADMIN_GET_SECTIONS_SUCCESS,
    ADMIN_GET_SECTION_SUCCESS,
    ADMIN_UPDATE_SECTION_SUCCESS,
    ADMIN_CREATE_SECTION_SUCCESS,
    ADMIN_DELETE_SECTION_SUCCESS,
    ADMIN_GET_LIST_ITEMS_SUCCESS,
    ADMIN_CREATE_LIST_ITEM_SUCCESS,
    ADMIN_UPDATE_LIST_ITEM_SUCCESS,
    ADMIN_DELETE_LIST_ITEM_SUCCESS,
    ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS,
    ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS,
    ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS,
    ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS,
    ADMIN_GET_GENERAL_SUCCESS,
    ADMIN_UPDATE_GENERAL_SUCCESS,
    ADMIN_CREATE_DEPOSIT_SUCCESS,
    ADMIN_UPDATE_DEPOSIT_SUCCESS,
    ADMIN_CREATE_MARKING_SUCCESS,
    ADMIN_UPDATE_MARKING_SUCCESS,
    ADMIN_GET_SECTION_PRIZE_SUCCESS,
    ADMIN_CREATE_SECTION_PRIZE_SUCCESS,
    ADMIN_UPDATE_SECTION_PRIZE_SUCCESS,
    ADMIN_DELETE_SECTION_PRIZE_SUCCESS,
    ADMIN_GET_KILOMETERS_SUCCESS,
    ADMIN_CREATE_KILOMETER_SUCCESS,
    ADMIN_UPDATE_KILOMETER_SUCCESS,
    ADMIN_DELETE_KILOMETER_SUCCESS,
    ADMIN_GET_CHAMPIONSHIPS_REQUEST,
    ADMIN_GET_CHAMPIONSHIPS_SUCCESS,
    ADMIN_GET_CHAMPIONSHIP_SUCCESS,
    ADMIN_CREATE_CHAMPIONSHIP_SUCCESS,
    ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS,
    ADMIN_DELETE_CHAMPIONSHIP_SUCCESS,
    ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS,
    ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS,
    ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS,
    ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS,
    ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS,
    ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS,
    ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS,
    ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS,
    ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
    ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
    ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
    ADMIN_START_SEASON_REQUEST,
    ADMIN_START_SEASON_SUCCESS,
    ADMIN_START_SEASON_FAILURE,
    ADMIN_GET_DASHBOARD_REQUEST,
    ADMIN_GET_DASHBOARD_SUCCESS,
    ADMIN_GET_DASHBOARD_FAILURE,
    ADMIN_CALC_SEATS_REQUEST,
    ADMIN_CALC_SEATS_SUCCESS,
    ADMIN_CALC_SEATS_FAILURE,
    ADMIN_SELECT_USER_ROLE_REQUEST, ADMIN_SELECT_USER_ROLE_SUCCESS, ADMIN_SELECT_USER_ROLE_FAILURE,
    ADMIN_SELECT_DATABASE_REQUEST, ADMIN_SELECT_DATABASE_SUCCESS, ADMIN_SELECT_DATABASE_FAILURE,
} from '../constants/actionconstants';
import initialStoreState from '../store/initialstorestate';

const initialState = initialStoreState.user;

import {mergeFunction} from "../../../common/src/util/lib";

const updateSection = (state, payload) => {
    return Object.assign({}, state, {
        sections: state.sections.merge(Immutable.Map([[payload.section.Sektionsnr, Object.assign({}, payload.section)]])),
        members: state.members.filter(member => member.Foreningsnr !== payload.contacts.Foreningsnr || payload.contacts.findIndex(sectionMember => sectionMember.Medlemsnr === member.Medlemsnr) >= 0)
            .mergeWith(mergeFunction, Immutable.Map(payload.contacts.map(contact => [contact.Medlemsnr, Object.assign({}, contact)]))),
            //.merge(Immutable.Map(typeof(payload.contacts) === 'undefined' ? [] : [[payload.contacts.Medlemsnr, Object.assign({}, payload.contacts)]])),
        clubs: state.clubs.mergeWith(mergeFunction, Immutable.Map(payload.clubs.map(club => [club.Foreningsnr, Object.assign({}, club)])))
    })
};

const updateSectionParameters = (state, payload, sectionNo) => {
    const stateSection = state.sections.get(sectionNo)
    return Object.assign({}, state, {
        sections: state.sections.merge(Immutable.Map([[sectionNo, Object.assign({}, stateSection, payload)]])),
    })
};

const updateClubParameters = (state, payload, clubNo) => {
    const stateClub = state.clubs.get(clubNo)
    return Object.assign({}, state, {
        clubs: state.clubs.merge(Immutable.Map([[clubNo, Object.assign({}, stateClub, payload)]])),
    })
};

const updateSectionPrize = (state, {data, id}) => {
    // if DDB
    if(id === 'ddb'){
        return Object.assign({}, state, {
            generalSection : Object.assign({}, state.generalSection, data),
        });
    // If regular section
    } else if (id.length === 2) {
        return updateSectionParameters(state, data, id);
    } else if (id.length === 3) {
        return updateClubParameters(state, data, id);
    }
}

const updateChampionship = (state, payload) => {
    payload.Mesterskabsflyvnings = Immutable.Map(payload.Mesterskabsflyvnings.map(championshipRace => [championshipRace.Kapflyvningsnr, Object.assign({}, championshipRace)]))
    payload.MesterskabDues = Immutable.Map(payload.MesterskabDues.map(pigeon => [pigeon.Ringnummer, Object.assign({}, pigeon)]))
    return Object.assign({}, state, {
        championships: state.championships.merge(Immutable.Map([[payload.RecNr, Object.assign({}, payload)]])),
    })
}

const updateClub = (state, payload) => {
    return Object.assign({}, state, {
        clubs: state.clubs.merge(Immutable.Map([[payload.club.Foreningsnr, Object.assign({}, payload.club)]])),
        members: state.members.filter(member => member.Foreningsnr !== payload.club.Foreningsnr || payload.members.findIndex(clubMember => clubMember.Medlemsnr === member.Medlemsnr) >= 0)
            .mergeWith(mergeFunction, Immutable.Map(payload.members.map(member => [member.Medlemsnr, Object.assign({}, member)])))
            .mergeWith(mergeFunction, Immutable.Map(payload.contacts.map(contact => [contact.Medlemsnr, Object.assign({}, contact)])))
            .merge(Immutable.Map(typeof(payload.member) === 'undefined' ? [] : [[payload.member.Medlemsnr, Object.assign({}, payload.member)]])),
        pigeonHoles: state.pigeonHoles.filter(hole => hole.Foreningsnr !== payload.club.Foreningsnr || payload.pigeonHoles.findIndex(clubHole => clubHole.Slagnr === hole.Slagnr) >= 0)
            .mergeWith(mergeFunction, Immutable.Map(payload.pigeonHoles.map(hole => [hole.Foreningsnr + '-' + hole.Slagnr, Object.assign({}, hole)])))
            .merge(Immutable.Map(typeof(payload.pigeonHole) === 'undefined' ? [] : [[payload.pigeonHole.Foreningsnr + '-' + payload.pigeonHole.Slagnr, Object.assign({}, payload.pigeonHole)]])),
    })
};

const updatePigeons = (state, payload) => {
    return Object.assign({}, state, {
        pigeonHoles: state.pigeonHoles.mergeWith(mergeFunction, Immutable.Map([[payload.Foreningsnr + '-' + payload.Slagnr, Object.assign({}, payload)]]))
    })
};

const updateOriginalAndNewClub = (state, payload) => {
    return Object.assign({}, state, {
        clubs: state.clubs
            .merge(Immutable.Map([[payload.originalClub.club.Foreningsnr, Object.assign({}, payload.originalClub.club)]]))
            .merge(Immutable.Map([[payload.newClub.club.Foreningsnr, Object.assign({}, payload.newClub.club)]])),
        members: state.members.filter((member => member.Foreningsnr !== payload.originalClub.club.Foreningsnr && member.Foreningsnr !== payload.newClub.club.Foreningsnr) ||
            (payload.originalClub.members.findIndex(clubMember => clubMember.Medlemsnr === member.Medlemsnr) >= 0) ||
            (payload.newClub.members.findIndex(clubMember => clubMember.Medlemsnr === member.Medlemsnr) >= 0))
            .mergeWith(mergeFunction, Immutable.Map(payload.originalClub.members.map(member => [member.Medlemsnr, Object.assign({}, member)])))
            .mergeWith(mergeFunction, Immutable.Map(payload.originalClub.contacts.map(contact => [contact.Medlemsnr, Object.assign({}, contact)])))
            .mergeWith(mergeFunction, Immutable.Map(payload.newClub.members.map(member => [member.Medlemsnr, Object.assign({}, member)])))
            .mergeWith(mergeFunction, Immutable.Map(payload.newClub.contacts.map(contact => [contact.Medlemsnr, Object.assign({}, contact)])))
            .merge(Immutable.Map(typeof(payload.member) === 'undefined' ? [] : [[payload.member.Medlemsnr, Object.assign({}, payload.member)]])),
        pigeonHoles: state.pigeonHoles.filter((hole => hole.Foreningsnr !== payload.originalClub.club.Foreningsnr && hole.Foreningsnr !== payload.newClub.club.Foreningsnr) ||
            (hole.Foreningsnr === payload.originalClub.club.Foreningsnr && payload.originalClub.pigeonHoles.findIndex(clubHole => clubHole.Foreningsnr === member.Foreningsnr && clubHole.Slagnr === member.Slagnr) >= 0) ||
            (hole.Foreningsnr === payload.newClub.club.Foreningsnr && payload.newClub.pigeonHoles.findIndex(clubHole => clubHole.Foreningsnr === member.Foreningsnr && clubHole.Slagnr === member.Slagnr) >= 0))
            .mergeWith(mergeFunction, Immutable.Map(payload.originalClub.pigeonHoles.map(hole => [hole.Foreningsnr + '-' + hole.Slagnr, Object.assign({}, hole)])))
            .mergeWith(mergeFunction, Immutable.Map(payload.newClub.pigeonHoles.map(hole => [hole.Foreningsnr + '-' + hole.Slagnr, Object.assign({}, hole)])))
            .merge(Immutable.Map(typeof(payload.pigeonHole) === 'undefined' ? [] : [[payload.pigeonHole.Foreningsnr + '-' + payload.pigeonHole.Slagnr, Object.assign({}, payload.pigeonHole)]])),
    });
};

export default createReducers(initialState, {
    [ADMIN_GET_BASICS_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
            isBasicsRead : true
        });
    },
    [ADMIN_GET_BASICS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            sections : state.sections.mergeWith(mergeFunction, Immutable.Map(payload.sections.map(section => {return [section.Sektionsnr, Object.assign({}, section)]}))).sort((s1, s2) => s1.Sektionsnr < s2.Sektionsnr ? -1 : 1),
            ranges : state.ranges.mergeWith(mergeFunction, Immutable.Map(payload.ranges.map(range => {return [range.Omraadenr, Object.assign({}, range)]}))).sort((s1, s2) => s1.Omraadenr < s2.Omraadenr ? -1 : 1),
            zipCodes : state.zipCodes.mergeWith(mergeFunction, Immutable.Map(payload.zipCodes.map(zip => {return [zip.Postnr, Object.assign({}, zip)]}))).sort((z1, z2) => z1.Postnr < z2.Postnr ? -1 : 1),
            userRoles: payload.userRoles,
            isBasicsRead: true
        });
    },
    [ADMIN_GET_CLUBS_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
            isClubsRead : true
        });
    },
    [ADMIN_GET_CLUBS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs : state.clubs.mergeWith(mergeFunction, Immutable.Map(payload.map(club => [club.Foreningsnr, Object.assign({}, club)]))),
            isClubsRead: true
        });
    },
    [ADMIN_GET_CLUB_SUCCESS] : (state, payload) => {
        return updateClub(state, payload);
    },
    [ADMIN_GET_MEMBERS_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
            isMembersRead : true
        });
    },
    [ADMIN_GET_MEMBERS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs : state.clubs.mergeWith(mergeFunction, Immutable.Map(payload.clubs.map(club => [club.Foreningsnr, Object.assign({}, club)]))),
            isClubsRead: true,
            members : state.members.mergeWith(mergeFunction, Immutable.Map(payload.members.map(member => [member.Medlemsnr, Object.assign({}, member)]))),
            isMembersRead: true,
        });
    },
    [ADMIN_GET_MEMBER_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs: state.clubs.mergeWith(mergeFunction, payload.club === null ? Immutable.Map([]) : Immutable.Map([[payload.club.Foreningsnr, Object.assign({}, payload.club)]])),
            members: state.members.merge(Immutable.Map([[payload.member.Medlemsnr, Object.assign({}, payload.member)]])),
            pigeonHoles: payload.pigeonHole === null ? state.pigeonHoles : state.pigeonHoles.mergeWith(mergeFunction, Immutable.Map([[payload.pigeonHole.Foreningsnr + '-' + payload.pigeonHole.Slagnr, Object.assign({}, payload.pigeonHole)]])),
        });
    },
    [ADMIN_GET_PIGEON_HOLE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs: state.clubs.mergeWith(mergeFunction, payload.club === null ? Immutable.Map([]) : Immutable.Map([[payload.club.Foreningsnr, Object.assign({}, payload.club)]])),
            pigeonHoles: state.pigeonHoles.merge(Immutable.Map([[payload.pigeonHole.Foreningsnr + '-' + payload.pigeonHole.Slagnr, Object.assign({}, payload.pigeonHole)]])),
        });
    },
    [ADMIN_CREATE_CLUB_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs: state.clubs.merge(Immutable.Map([[payload.club.Foreningsnr, Object.assign({}, payload.club)]])),
        })
    },
    [ADMIN_UPDATE_CLUB_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, payload.originalClubNo === payload.club.Foreningsnr ? updateClub(state, payload) : {
            clubs: state.clubs.delete(payload.originalClubNo).merge(Immutable.Map([[payload.club.Foreningsnr, Object.assign({}, payload.club)]])),
            members: state.members.filter(member => member.Foreningsnr !== payload.originalClubNo && member.Foreningsnr !== payload.club.Foreningsnr)
                .mergeWith(mergeFunction, Immutable.Map(payload.members.map(member => [member.Medlemsnr, Object.assign({}, member)])))
                .mergeWith(mergeFunction, Immutable.Map(payload.contacts.map(contact => [contact.Medlemsnr, Object.assign({}, contact)]))),
            pigeonHoles: state.pigeonHoles.filter(hole => hole.Foreningsnr !== payload.originalClubNo && hole.Foreningsnr !== payload.club.Foreningsnr)
                .mergeWith(mergeFunction, Immutable.Map(payload.pigeonHoles.map(hole => [hole.Foreningsnr + '-' + hole.Slagnr, Object.assign({}, hole)]))),
        })
    },
    [ADMIN_DELETE_CLUB_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs : state.clubs.delete(payload),
            members : state.members.filter(member => member.Foreningsnr !== payload),
            pigeonHoles : state.pigeonHoles.filter(hole => hole.Foreningsnr !== payload),
        })
    },
    [ADMIN_CREATE_MEMBER_SUCCESS]: (state, payload) => {
        return updateClub(state, payload);
    },
    [ADMIN_UPDATE_MEMBER_SUCCESS] : (state, payload) => {
        if (typeof(payload.originalClub) === 'undefined') return updateClub(state, payload);
        else return updateOriginalAndNewClub(state, payload);
    },
    [ADMIN_DELETE_MEMBER_SUCCESS] : (state, payload) => {
        return updateClub(state, payload);
    },
    [ADMIN_CREATE_PIGEONHOLE_SUCCESS]: (state, payload) => {
        return updateClub(state, payload);
    },
    [ADMIN_UPDATE_PIGEONHOLE_SUCCESS] : (state, payload) => {
        if (typeof(payload.originalClub) === 'undefined') return updateClub(state, payload);
        else return updateOriginalAndNewClub(state, payload);
    },
    [ADMIN_DELETE_PIGEONHOLE_SUCCESS] : (state, payload) => {
        return updateClub(state, payload);
    },
    [ADMIN_CREATE_PIGEON_SUCCESS] : (state, payload) => {
        return updatePigeons(state, payload);
    },
    [ADMIN_UPDATE_PIGEON_SUCCESS] : (state, payload) => {
        return updatePigeons(state, payload);
    },
    [ADMIN_DELETE_PIGEON_SUCCESS] : (state, payload) => {
        return updatePigeons(state, payload);
    },
    [ADMIN_CREATE_PIGEONS_SUCCESS] : (state, payload) => {
        return updatePigeons(state, payload);
    },
    [ADMIN_UPDATE_PIGEONS_SUCCESS] : (state, payload) => {
        return updatePigeons(state, payload);
    },
    [ADMIN_DELETE_PIGEONS_SUCCESS] : (state, payload) => {
        return updatePigeons(state, payload);
    },
    [ADMIN_CREATE_RINGSERIE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs: state.clubs.mergeWith(mergeFunction, Immutable.Map([[payload.club, {ringSeries: payload.rings}]])),
        });
    },
    [ADMIN_UPDATE_RINGSERIE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs: state.clubs.mergeWith(mergeFunction, Immutable.Map([[payload.club, {ringSeries: payload.rings}]])),
        });
    },
    [ADMIN_DELETE_RINGSERIE_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs: state.clubs.mergeWith(mergeFunction, Immutable.Map([[payload.club, {ringSeries: payload.rings}]])),
        });
    },
    [ADMIN_GET_STATION_SELECTIONS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            stations : state.stations.mergeWith(mergeFunction, Immutable.Map(payload.stations.map(station => {return [station.Stationsnr, Object.assign({}, station)]}))),
            stationSelections: state.stationSelections.mergeWith(mergeFunction, Immutable.Map(payload.selections.map(selection => {return [selection.target + '|' + selection.station, Object.assign({}, selection)]}))),
        });
    },
    [ADMIN_SELECT_STATIONS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            stationSelections: state.stationSelections.mergeWith(mergeFunction, Immutable.Map(payload.map(selection => {return [selection.target + '|' + selection.station, Object.assign({}, selection)]}))),
        });
    },
    [ADMIN_UNSELECT_STATIONS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            stationSelections: state.stationSelections.filter(selection => payload.findIndex(deleted => deleted.target === selection.target && deleted.station === selection.station) < 0),
        });
    },
    [ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs : Immutable.Map(payload.map(club => [club.Foreningsnr, Object.assign({}, club)])),
            isClubsRead: true
        });
    },
    [ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS] : (state, payload) => {
        return updateClub(state, payload);
    },
    [ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs : Immutable.Map(payload.map(club => [club.Foreningsnr, Object.assign({}, club)])),
            isClubsRead: true
        });
    },
    [ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS] : (state, payload) => {
        return updateClub(state, payload);
    },
    [ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs : Immutable.Map(payload.map(club => [club.Foreningsnr, Object.assign({}, club)])),
            isClubsRead: true
        });
    },
    [ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS] : (state, payload) => {
        return updateClub(state, payload);
    },
    [ADMIN_RESET_UPDATE_MARKINGS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            clubs : Immutable.Map(payload.map(club => [club.Foreningsnr, Object.assign({}, club)])),
            isClubsRead: true
        });
    },
    [ADMIN_GET_SECTIONS_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
            isSectionsRead : true
        });
    },
    [ADMIN_GET_SECTIONS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            sections : state.sections.mergeWith(mergeFunction, Immutable.Map(payload.map(section => [section.Sektionsnr, Object.assign({}, section)]))),
            isSectionsRead: true
        });
    },
    [ADMIN_GET_SECTION_SUCCESS] : (state, payload) => {
        return updateSection(state, payload);
    },
    [ADMIN_UPDATE_SECTION_SUCCESS] : (state, payload) => {
        return updateSection(state, payload);
    },
    [ADMIN_CREATE_SECTION_SUCCESS] : (state, payload) => {
        return updateSection(state, payload);
    },
    [ADMIN_DELETE_SECTION_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            sections : state.sections.delete(payload),
        })
    },
    [ADMIN_GET_GENERAL_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            generalSection : payload,
            isGeneralSectionRead: true
        });
    },
    [ADMIN_UPDATE_GENERAL_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            generalSection : payload,
            isGeneralSectionRead: true
        });
    },
    [ADMIN_GET_LIST_ITEMS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            [payload.state] : state[payload.state].mergeWith(mergeFunction, Immutable.Map(payload.data.map(entity => [entity[payload.key], Object.assign({}, entity)]))),
        });
    },
    [ADMIN_CREATE_LIST_ITEM_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            [payload.state] : state[payload.state].merge(Immutable.Map([[payload.entity[payload.key], Object.assign({}, payload.entity)]])),
        });
    },
    [ADMIN_UPDATE_LIST_ITEM_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            [payload.state] : state[payload.state].delete(payload.oldKeyValue).merge(Immutable.Map([[payload.entity[payload.key], Object.assign({}, payload.entity)]])),
        });
    },
    [ADMIN_DELETE_LIST_ITEM_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            [payload.state] : state[payload.state].delete(payload.keyValue),
        });
    },
    [ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            errorLists: Object.assign({}, state.errorLists, {
                [payload.state]: state.errorLists[payload.state].mergeWith(mergeFunction, Immutable.Map(payload.data.map(entity => [entity.id, Object.assign({}, entity)]))),
            }),
        });
    },
    [ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            errorLists: Object.assign({}, state.errorLists, {
                [payload.state]: state.errorLists[payload.state].delete(payload.oldKey).merge(Immutable.Map([[payload.data.id, Object.assign({}, payload.data)]])),
            }),
        });
    },
    [ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            errorLists: Object.assign({}, state.errorLists, {
                [payload.state] : state.errorLists[payload.state].filter(entity => payload.deleted.indexOf(entity.id) < 0),
            }),
        });
    },
    [ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            errorLists: Object.assign({}, state.errorLists, {
                [payload.state] : state.errorLists[payload.state].filter(entity => payload.accepted.indexOf(entity.id) < 0).mergeWith(mergeFunction, Immutable.Map(payload.failed.map(entity => [entity.data.id, Object.assign({}, entity.data)]))),
            }),
        });
    },
    [ADMIN_CREATE_DEPOSIT_SUCCESS] : (state, payload) => {
        if(payload.hasOwnProperty('section')) return updateSection(state, payload);
        else if(payload.hasOwnProperty('club')) return updateClub(state, payload);
        else return Object.assign({}, state, {
            generalSection : payload,
            isGeneralSectionRead: true
        });
    },
    [ADMIN_UPDATE_DEPOSIT_SUCCESS] : (state, payload) => {
        if(payload.hasOwnProperty('section')) return updateSection(state, payload);
        else if(payload.hasOwnProperty('club')) return updateClub(state, payload);
        else return Object.assign({}, state, {
            generalSection : payload,
            isGeneralSectionRead: true
        });
    },
    [ADMIN_CREATE_MARKING_SUCCESS] : (state, payload) => {
        if(payload.hasOwnProperty('section')) return updateSection(state, payload);
        else if(payload.hasOwnProperty('club')) return updateClub(state, payload);
        else return Object.assign({}, state, {
            generalSection : payload,
            isGeneralSectionRead: true
        });
    },
    [ADMIN_UPDATE_MARKING_SUCCESS] : (state, payload) => {
        if(payload.hasOwnProperty('section')) return updateSection(state, payload);
        else if(payload.hasOwnProperty('club')) return updateClub(state, payload);
        else return Object.assign({}, state, {
            generalSection : payload,
            isGeneralSectionRead: true
        });
    },
    [ADMIN_GET_SECTION_PRIZE_SUCCESS] : (state, payload) => {
       return updateSectionPrize(state, payload)
    },
    [ADMIN_CREATE_SECTION_PRIZE_SUCCESS] : (state, payload) => {
        return updateSectionPrize(state, payload)
    },
    [ADMIN_UPDATE_SECTION_PRIZE_SUCCESS] : (state, payload) => {
        return updateSectionPrize(state, payload)
    },
    [ADMIN_DELETE_SECTION_PRIZE_SUCCESS] : (state, payload) => {
        return updateSectionPrize(state, payload)
    },

    [ADMIN_GET_KILOMETERS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            kmFactors: payload
        })
    },
    [ADMIN_CREATE_KILOMETER_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            kmFactors: payload
        })
    },
    [ADMIN_UPDATE_KILOMETER_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            kmFactors: payload
        })
    },
    [ADMIN_DELETE_KILOMETER_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            kmFactors: payload
        })
    },
    [ADMIN_GET_CHAMPIONSHIPS_REQUEST] : (state, payload) => {
        return Object.assign({}, state, {
            isChampionshipsRead : true
        });
    },
    [ADMIN_GET_CHAMPIONSHIPS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            championships : state.championships.mergeWith(mergeFunction, Immutable.Map(payload.map(championship => [championship.RecNr, Object.assign({}, championship)]))),
            isChampionshipsRead: true
        });
    },
    [ADMIN_GET_CHAMPIONSHIP_SUCCESS] : (state, payload) => {
        return updateChampionship(state, payload)
    },
    [ADMIN_CREATE_CHAMPIONSHIP_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            championships: state.championships.merge(Immutable.Map([[payload.RecNr, Object.assign({}, payload)]])),
        })
    },
    [ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS] : (state, payload) => {
        return updateChampionship(state, payload)
    },
    [ADMIN_DELETE_CHAMPIONSHIP_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            championships : state.championships.delete(payload),
        });
    },
    [ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS] :  (state, payload) => {
        const championshipRaces = state.championships.get(payload.MesterskabsId).Mesterskabsflyvnings.merge(Immutable.Map([[payload.Kapflyvningsnr, Object.assign({}, payload)]]))

        // creating a copy of the state, so it will not be directly modified
        let championships = state.championships
        championships.get(payload.MesterskabsId).Mesterskabsflyvnings = championshipRaces

        return Object.assign({}, state, {
            championships: championships
        })
    },
    [ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS] :  (state, payload) => {
        const championshipRaces = state.championships.get(payload.MesterskabsId).Mesterskabsflyvnings.merge(Immutable.Map([[payload.Kapflyvningsnr, Object.assign({}, payload)]]))

        // creating a copy of the state, so it will not be directly modified
        let championships = state.championships
        championships.get(payload.MesterskabsId).Mesterskabsflyvnings = championshipRaces

        return Object.assign({}, state, {
            championships: championships
        })
    },
    [ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS] :  (state, {championshipNo, raceNo}) => {
        const championshipRaces = state.championships.get(championshipNo).Mesterskabsflyvnings.delete(raceNo)

        // creating a copy of the state, so it will not be directly modified
        let championships = state.championships
        championships.get(championshipNo).Mesterskabsflyvnings = championshipRaces

        return Object.assign({}, state, {
            championships: championships
        })
    },
    [ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS] :  (state, payload) => {
        return updateChampionship(state, payload)
    },
    [ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS] :  (state, payload) => {
        return updateChampionship(state, payload)
    },
    [ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS] :  (state, payload) => {
        const championshipRaces = state.championships.get(payload.MesterskabsId).MesterskabDues.merge(Immutable.Map([[payload.Ringnummer, Object.assign({}, payload)]]))

        // creating a copy of the state, so it will not be directly modified
        let championships = state.championships
        championships.get(payload.MesterskabsId).MesterskabDues = championshipRaces

        return Object.assign({}, state, {
            championships: championships
        })
    },
    [ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS] :  (state, payload) => {
        return updateChampionship(state, payload)
    },
    [ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS] : (state, {championshipNo, ringNo}) => {
        const ringNumbers = state.championships.get(championshipNo).MesterskabDues.delete(ringNo)

        // creating a copy of the state, so it will not be directly modified
        let championships = state.championships
        championships.get(championshipNo).MesterskabDues = ringNumbers

        return Object.assign({}, state, {
            championships: championships
        })
    },
    [ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS] :  (state, payload) => {
        return updateChampionship(state, payload)
    },
    [ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS] :  (state, payload) => {
        return updateChampionship(state, payload)
    },
    [ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS] :  (state, payload) => {
        return updateChampionship(state, payload)
    },
    [ADMIN_GET_DASHBOARD_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            archives: payload.archives.sort((db1, db2) => db1 < db2 ? 1 : (db1 > db2 ? -1 : 0)),
        })
    },
    [ADMIN_START_SEASON_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            isChampionshipsRead: false,
            championships: new Immutable.Map(),
        })
    },
    [ADMIN_CALC_SEATS_SUCCESS] : (state, payload) => {
        return Object.assign({}, state, {
            generalSection: Object.assign({}, state.generalSection, payload),
        })
    },
    [ADMIN_SELECT_USER_ROLE_SUCCESS] : (state, {championshipNo, ringNo}) => {
        return Object.assign({}, initialStoreState.admin, {archives: state.archives, userRoles: state.userRoles});
    },
    [ADMIN_SELECT_DATABASE_SUCCESS] : (state, {championshipNo, ringNo}) => {
        return Object.assign({}, initialStoreState.admin, {archives: state.archives, userRoles: state.userRoles});
    }
})


// WEBPACK FOOTER //
// ./src/client/src/reducers/admin.js